import React, { useContext, useState } from "react";
import Header from "../Headers/Header";
import { useLanguage } from "../LanguageContext";
import Button from "../Button";
import Input from "../Input";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { forgotPasswordTranslations } from "./forgotPasswordTranslations";
import { Language } from "../../Types/types";
import { getBaseUrl } from "../Manual_List/fetch/baseEndpoint";
import { ThemeContext } from "../../hooks/themeContext";
import logo from "../../assets/ar encyclopedy.png";

const ForgotPassword: React.FC = () => {
  const { language } = useLanguage();
  const [username, setUser] = useState("");
  const [sent, setSent] = useState(false);
  const [responseLabel, setResponseLabel] = useState("");
  const [responseMessage, setResponseMessage] = useState("");
  const navigate = useNavigate();

  const { isDark } = useContext(ThemeContext);

  const t = forgotPasswordTranslations[language as Language];

  const handleForgotPass = async () => {
    try {
      await axios.post(`${getBaseUrl()}/user/forgotten-password`, {
        username,
      });
    } catch (error) {
      console.error("Error sending forgot password request:", error);
    }
  };

  const handleSend = async () => {
    setSent(true);
    await handleForgotPass();
  };

  const handleUser = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUser(event.target.value);
  };

  const preventEnterKeySubmit = (
    event: React.KeyboardEvent<HTMLFormElement>
  ) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-100 relative z-10 transition-all">
      <div className="absolute w-full z-20 bg-white top-0 h-10">
        <Header hideLogo={true} />
      </div>
      {isDark ? (
        <img
          src="./gradient_background_dark.jpg"
          className="cover w-full h-screen"
        />
      ) : (
        <img
          src="./gradient_background.jpg"
          className="cover w-full h-screen"
        />
      )}
      <div className="flex flex-col items-center justify-center flex-grow absolute inset-0">
        <img
          src={logo}
          alt="AR ENCYCLOPEDY LOGO"
          className="h-12 w-auto mb-5 mt-4"
        />
        {!sent ? (
          <form
            className="dark:bg-darkSecondaryBackground bg-white rounded-2xl sm:shadow-md sm:mb-20 sm:py-10 sm:px-16 p-4 max-w-lg flex flex-col justify-between min-h-96"
            onKeyDown={preventEnterKeySubmit}
          >
            <div className="flex justify-center">
              <div className="font-semibold text-purple text-3xl">
                {t.resetPassword}
              </div>
            </div>
            <div className="mb-4">
              <label className="text-gray dark:text-white font-light">
                {t.username}
              </label>
              <input
                type="text"
                className={`w-full px-3 py-2 rounded-md border border-purple dark:bg-darkSecondaryBackground dark:text-white outline-none`}
                value={username}
                onChange={handleUser}
              />
            </div>
            <div className="w-full p-1 ">
              <button
                onClick={handleSend}
                className="w-full bg-purple hover:bg-darkPurple text-white px-3 py-2 rounded-full font-medium mb-4 transition-all"
              >
                {t.sendButton}
              </button>
              <button
                className="w-full border-purple dark:border-white border dark:hover:text-black hover:bg-lightPurple dark:text-white text-purple px-3 py-2 rounded-full font-medium transition-all"
                onClick={() => navigate("/login")}
              >
                {t.discardButton}
              </button>
            </div>
          </form>
        ) : (
          <div className="dark:bg-darkSecondaryBackground bg-white rounded-2xl sm:shadow-md sm:mb-20 sm:py-10 sm:px-16 p-4 max-w-lg flex flex-col justify-between min-h-96">
            <div className="flex justify-center mb-4">
              <h1 className="font-semibold text-purple text-3xl text-center">
                {t.emailSent}
              </h1>
            </div>

            <div className="flex items-center justify-center text-center mb-4 max-w-72 dark:text-white mx-auto">
              {t.emailSentMessage}
            </div>
            <button
              onClick={() => navigate("/login")}
              className="w-full bg-purple hover:bg-darkPurple text-white px-3 py-2 rounded-full font-medium mb-4 transition-all"
            >
              {t.loginButton}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
